
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
components: {
Msg,
Divider,
XButton,
XHeader,
Flow,
FlowState,
FlowLine,
TransferDom,
Popup
},
data () {
return {
workList: [],
id: '',
loading: true,
hasShowPopup: {
data: false
}
}
},
created () {
this.id = this.$route.query.id
},
methods: {
showStep () {

this.$router.push({name: 'onboard.list', query: {id: this.id}})
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/404.vue